<!-- dont autoload, if address already set -->
<!-- TODO make margins left and right same as formly fields below -->
<div class="phx-formly-padded mb-2">
    <label
        class="font-bold"
        *ngIf="this.model?.documentDefinition?.documentDirection === 'IN'"
        [attr.data-testid]="'formly-invoice-receiver-address-widget-label-1'"
        >{{ 'document.vendor' | translate }}</label
    >
    <label
        class="font-bold"
        *ngIf="this.model?.documentDefinition?.documentDirection === 'OUT'"
        [attr.data-testid]="'formly-invoice-receiver-address-widget-label-2'"
        >{{ 'document.customer' | translate }}</label
    >
    <label
        *ngIf="!this.model?.documentDefinition?.documentDirection"
        [attr.data-testid]="'formly-invoice-receiver-address-widget-label-3'"
        >{{ 'document.address' | translate }}</label
    >

    <!-- <a
        *ngIf="model?.address?.id"
        [href]="getDetailUrl(model.address)"
        class="phx-icon-link"
        target="_blank"
    >
        <i class="fa fa-external-link-alt link-primary ml-1"></i>
    </a> -->
    <!-- right now all address dropdowns are blocked if address is blocked for one thing in the document -->
    <app-address-drop-down
        class="font-bold"
        [disabled]="model.status === 'CO' || model.status === 'RE'"
        [value]="this.model?.invoiceReceiverAddress"
        [placeholder]="'document.invoice-receiver-addresses' | translate"
        (valueChange)="selectedAddressChanged($event)"
        [showOnlyCreditors]="this.showCreditor()"
        [showOnlyDebitors]="this.showDebitor()"
        [allowForProspects]="model?.documentDefinition?.allowForProspects"
        [documentDirection]="model?.documentDefinition?.documentDirection"
        [deliveryRelevant]="model?.documentDefinition?.deliveryRelevant"
        [autoloadItems]="false"
        [externalDataTestId]="true"
        [dataTestId]="'formly-invoice-receiver-address-widget-address-drop-down'"
    />
</div>

<form
    *ngIf="subForm"
    [formGroup]="subForm"
    [disableForm]="{ state: model.status === 'CO' || model.status === 'RE', form: subForm }"
>
    <formly-form [model]="newModel" [fields]="fallbackFields" [form]="subForm" [options]="options">
    </formly-form>
</form>

<!-- {{ model.address | json}} -->

<!-- nm: {{newModel | json}} -->
